import PortfoliosForm from 'src/javascripts/components/forms/PortfoliosForm';

export default class PortfoliosEdit {

  constructor() {}

  render() {

    // Portfolios form
    PortfoliosForm();

  }

}